var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.644 41.197L89.9666 47.9391L77.0803 25.6192L88.7579 18.8772C90.6466 17.7867 93.0716 18.4365 94.162 20.3252L103.092 35.7929C103.411 36.3451 103.582 36.9532 103.618 37.5516C103.693 38.9932 102.982 40.4204 101.646 41.1921L101.644 41.197Z",
    fill: "#F24968"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2991 21.547C92.8356 21.0992 92.3233 20.6755 91.7077 20.4787C91.0921 20.282 90.3653 20.3418 89.8846 20.77C89.241 21.3507 89.2378 22.3523 89.4123 23.2053C89.794 25.0474 90.7817 26.7654 92.1861 28.0169C92.6697 28.4488 93.2138 28.8333 93.837 29.0215C94.4602 29.2097 95.1692 29.1769 95.7145 28.8244C96.9395 28.0335 96.3978 26.4721 95.9446 25.4118C95.3302 23.9636 94.4278 22.6397 93.2991 21.547Z",
    fill: "#F24968"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.644 41.197L89.9666 47.9391L77.0803 25.6192L80.8515 23.4419C81.2274 24.8104 81.7294 26.1436 82.3507 27.408C84.675 32.1946 88.8269 36.1979 93.9148 37.7574C97.0529 38.715 100.536 38.6406 103.618 37.5516C103.693 38.9932 102.982 40.4204 101.646 41.1921L101.644 41.197Z",
    fill: "#F24968"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2027 63.0763L0 85.0015L25.0891 85.3962L32.575 81.0742L19.6887 58.7543L12.2027 63.0763Z",
    fill: "#F9DEB2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.652 35.7891L16.4997 70.5181C16.7883 69.0254 16.5618 67.4158 15.7394 65.9914C14.917 64.567 13.6413 63.5674 12.203 63.0759L72.3616 28.3433L76.6583 35.7855L76.652 35.7891Z",
    fill: "#F29F05"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2432 50.6623L25.0895 85.3962C25.3781 83.9035 25.1517 82.2939 24.3293 80.8695C23.5069 79.4451 22.2312 78.4455 20.7928 77.954L80.9514 43.2214L85.2482 50.6636L85.2432 50.6623Z",
    fill: "#F29F05"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9537 43.2327L20.7888 77.9689C21.08 76.4662 20.8559 74.8679 20.0298 73.4372C19.2038 72.0065 17.9317 71.0132 16.4848 70.5141L76.6497 35.7779L80.9537 43.2327Z",
    fill: "#F28705"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9565 79.6885L6.07937 85.0975L0 85.0015L2.9565 79.6885Z",
    fill: "#0D0D0D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4426 50.032L87.8282 52.1188C87.3074 52.4195 86.6281 52.2427 86.3238 51.7156L71.9883 26.8858C71.684 26.3587 71.8706 25.6821 72.3914 25.3814L76.0057 23.2946C76.5266 22.9939 77.1996 23.1743 77.5052 23.6964L91.8407 48.5262C92.1451 49.0533 91.9647 49.7264 91.439 50.0258L91.4426 50.032Z",
    fill: "#BFBEB8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9765 51.4558L86.3223 52.9883C85.8014 53.289 85.1221 53.1123 84.8178 52.5852L70.4823 27.7553C70.178 27.2282 70.3646 26.5516 70.8854 26.2509L73.5397 24.7184C73.0189 25.0191 72.8323 25.6958 73.1366 26.2229L87.4721 51.0527C87.7764 51.5798 88.4557 51.7565 88.9765 51.4558Z",
    fill: "#A6A59F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilCursor);
export default __webpack_public_path__ + "static/media/PencilCursor.7949fda70e105b85438e736f8976b729.svg";
export { ForwardRef as ReactComponent };